import { isPlatformWeb } from '../utilities/platform.util'
import { createAESKey, createPassKey, stringToSalt } from '../utilities'
import { DeviceInfoService } from './deviceInfo.service'
import { DB_NAME_PREFIX } from './indexDb.service'
import { NowIndexDbService } from './nowIndexDb.service'
import { NowSQLiteDbService } from './nowSQLiteDb.service'

export type IndexableTypePart = string | number | Date | ArrayBuffer | ArrayBufferView | DataView | Array<Array<void>>
export type IndexableTypeArray = Array<IndexableTypePart>

export class DatabaseUtilityService {
  static instance: NowSQLiteDbService | NowIndexDbService
  static indexDbServiceInstance: NowIndexDbService
  static database: string
  static indexDbServiceDatabase: string

  static getInstance(database: string) {
    if (!this.instance || this.database !== database) {
      this.database = database
      this.instance = isPlatformWeb() ? new NowIndexDbService(database) : new NowSQLiteDbService(database)
    }
    return this.instance
  }

  static getIndexDbServiceInstance(database: string): NowIndexDbService {
    if (!this.indexDbServiceInstance || this.indexDbServiceDatabase !== database) {
      this.indexDbServiceDatabase = database
      this.indexDbServiceInstance = new NowIndexDbService(database)
    }
    return this.indexDbServiceInstance
  }

  static async getEncryptionKeyForSettingsDB(database: string): Promise<Uint8Array> {
    const rawKey = `${process.env.REACT_APP_KEY_FOR_SETTINGS}`
    const passKey = await createPassKey(rawKey)
    const salt = stringToSalt(database)
    return await createAESKey(passKey, salt)
  }

  static async getEncryptionKeyForServiceDB(database: string): Promise<Uint8Array> {
    const deviceInfoService = new DeviceInfoService()
    const deviceInfo = await deviceInfoService.createOrGet()

    const sid = database.slice(DB_NAME_PREFIX.length)

    const rawKey = `${sid}_${deviceInfo.uuid}`
    const passKey = await createPassKey(rawKey)
    const salt = deviceInfo.salt
    return await createAESKey(passKey, salt)
  }
}
